import axios from '@axios'
import baseConfig from "@/../baseConfig";

export default {
  namespaced: true,
  state: {
    user: {
      currentOrganizationId: 0
    },
  },
  getters: {
    getUser(state) {
      return state.user
    },
  },
  mutations: {
    setUser(state, { user }) {
      state.user = user
    },
  },
  actions: {
    async setUser({ commit },user) {
      commit('setUser', user)
    },
  },
}
